// extracted by mini-css-extract-plugin
export default {"App":"Main_App__EEaDX"};